import { ListBannersReducer } from '../interfaces';
import { createReducer } from '@reduxjs/toolkit';
import store from 'store2';

const initialState: ListBannersReducer = {
  status: {
    loading: false,
    error: false,
    done: false,
  },
  data: null,
};

const listBannersReducer = createReducer(initialState, {
  GET_BANNERS_PENDING: (state) => {
    state.status = {
      loading: true,
      error: false,
      done: false,
    };
  },

  GET_BANNERS_FULFILLED: (state, action) => {
    state.status = {
      loading: false,
      error: false,
      done: true,
    };
    state.data = action.payload.data;
  },

  GET_BANNERS_REJECTED: (state) => {
    state.status = {
      loading: false,
      error: true,
      done: false,
    };
    state.data = null;
  },
});

export default listBannersReducer;
